import React from 'react';

import Dim from 'web/components/common/modal/common/Dim';

import { trigger } from 'shared/utils/channelTalk';

import classNames from 'classnames/bind';
import styles from './DropOutCheck.scss';
const cx = classNames.bind(styles);

const DropOutCheck = React.memo(
  ({ handleOneToOne, handlePopup, isController = false }) => {
    return (
      <Dim>
        <div className={cx('DropOutCheck')} onClick={e => e.stopPropagation()}>
          <div className="guide-message">
            탈퇴하면 구매한 이용권을
            <br />
            더 이상 이용하실 수 없습니다.
            <br />
            탈퇴를 원하시는 경우
            <br />
            고객센터에 문의해주세요.
            <br />
          </div>

          <div className="buttons">
            <button
              type="button"
              className="btn point"
              onClick={handlePopup.close}
            >
              닫기
            </button>
            <button
              type="button"
              className={`btn gtm-contact`}
              id="channelIoButton"
              onClick={trigger}
            >
              1:1 문의
            </button>
          </div>
        </div>
      </Dim>
    );
  },
);

export default DropOutCheck;
